import { PointSetting } from './../models/commission/point-setting';
import { CurrencyExchangeRateResult } from './../models/currencyExchangeRateResult';
import { CurrencyList } from './../models/currency-list';
export namespace PointHelper {

	export function getPoint(amount: number, point: PointSetting, currency: CurrencyList, exchangeRate: CurrencyExchangeRateResult): number {
		if (currency.id !== point.basCurrencyId) {
			let actionIsbuy = exchangeRate.actionIsBuy;
			amount = actionIsbuy
				? toFixedScale((amount * exchangeRate['exchangeRate']), currency.precision)
				: toFixedScale((amount / exchangeRate['exchangeRate']), currency.precision);
		}

		return (amount * point.howManyPoints) / point.howManyCurrency;
	}

	function toFixedScale(num, scale: number): number {
		const converNume = parseFloat(num).toFixed((scale + 1));
        return parseFloat(converNume.substring(0, (converNume.length-1)));
	}
}
